import { Box, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import useStyles from '../../../../../../styles/global-mui.js';
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

const SelectQuizzOptions = ({onChange, event}) => {

    const classes = useStyles();

    return(
        <Box className="survey-form small-padding">
            <Box className='centered-wrapper'>
                <Typography variant='body1' fontWeight="bold">Options</Typography>
            </Box>

            <Box className='small-padding' sx={{paddingTop:0}}>
                <Typography className={classes.customInputLabel}>Nombre de réponses souhaitées</Typography>
                <TextField
                    type="number"
                    fullWidth
                    className={`input-field ${classes.customInput}`}
                    placeholder="Saisir le nombre de réponses souhaitées..."
                    value={event.numberOfChoices ?? ""}
                    onChange={(e) => {
                    const value = e.target.value;

                        if (value === "") {
                        // ✅ Champ vidé = désélection
                        onChange("options", {
                            ...event.options,
                            numberOfChoices: undefined,
                        });
                        } else if (!isNaN(Number(value))) {
                        // ✅ Conversion sécurisée
                        onChange("options", {
                            ...event.options,
                            numberOfChoices: parseInt(value, 10),
                        });
                        }
                    }}
                    InputProps={{
                        endAdornment: (
                        <InputAdornment
                            position="end"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center", // ✅ centre verticalement
                                height: "100%",            // ✅ limite la hauteur à celle de l'input
                                marginRight: "4px",        // ✅ petit espace avec le bord droit
                                '& .MuiIconButton-root': {
                                padding: "2px",          // ✅ réduit l'espace intérieur
                                },
                                '& svg': {
                                fontSize: "16px",        // ✅ réduit la taille des chevrons
                                }
                            }}
                            >
                            <IconButton
                                size="small"
                                onClick={() =>
                                onChange("options", {
                                    ...event.options,
                                    numberOfChoices: Math.min((event.numberOfChoices || 0) + 1, 99),
                                })
                                }
                            >
                                <KeyboardArrowUp />
                            </IconButton>
                            <IconButton
                                size="small"
                                onClick={() =>
                                onChange("options", {
                                    ...event.options,
                                    numberOfChoices: Math.max((event.numberOfChoices || 0) - 1, 0),
                                })
                                }
                            >
                                <KeyboardArrowDown />
                            </IconButton>
                            </InputAdornment>

                        ),
                    }}
                    //cacher les cheverons natifs
                    sx={{
                        '& input[type=number]': {
                        MozAppearance: 'textfield', // ✅ pour Firefox
                        },
                        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                        WebkitAppearance: 'none', // ✅ pour Chrome/Safari
                        margin: 0,
                        },}}
                    />
            </Box>

             <Box className='small-padding' sx={{paddingBottom:0}}>
                <Typography className={classes.customInputLabel}>Valider les réponses manuellement</Typography>
                <input
                    type="checkbox"
                    className={`input-field ${classes.customInput}`}
                    checked={event.validate}
                    onChange={(e) => onChange("options", {...event.options, validate : e.target.checked})}
                />
            </Box>

        </Box>
    )
}

export default SelectQuizzOptions